import { useLoading } from "./LoadingContext";

export default function GlobalLoader() {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700"></div>
</div>
  );
}